import { ref, reactive } from "vue";
const storedHotModules = JSON.parse(
  sessionStorage.getItem("hotModules") || "[]"
);
const _hotModules = ref(new Set(storedHotModules));
const hotModules = {
  entries: _hotModules,
  add: (npmName) => {
    _hotModules.value.add(npmName);
    sessionStorage.setItem(
      "hotModules",
      JSON.stringify(Array.from(_hotModules.value))
    );
  },
  remove: (npmName) => {
    _hotModules.value.delete(npmName);
    sessionStorage.setItem(
      "hotModules",
      JSON.stringify(Array.from(_hotModules.value))
    );
  }
};
const isMfHot = (npmName) => _hotModules.value.has(npmName);
const socketStatuses = reactive({});
const sockets = ref({});
const connectWebSocket = (component, port, onConnect) => {
  let timeout;
  const socket = new WebSocket(`ws://localhost:${port}/ws`);
  socket.onerror = function() {
    socketStatuses[component] = "refused";
  };
  socket.onopen = () => {
    clearTimeout(timeout);
    socketStatuses[component] = "connected";
    onConnect();
  };
  socket.onmessage = (event) => {
    const msgData = JSON.parse(event.data);
    switch (msgData.type) {
      case "ok":
      case "still-ok":
        socketStatuses[component] = "ok";
        break;
      case "invalid":
        socketStatuses[component] = "compiling";
        break;
      case "errors":
        socketStatuses[component] = "error";
        break;
    }
  };
  socket.onclose = () => {
    if (isMfHot(component)) {
      socketStatuses[component] = "disconnected";
      timeout = setTimeout(() => {
        clearTimeout(timeout);
        connectWebSocket(component, port, onConnect);
      }, 1e3);
    }
  };
  return socket;
};
export {
  connectWebSocket,
  hotModules,
  isMfHot,
  socketStatuses,
  sockets
};
